/**
 * Generate new contract id
 * @returns {Promise<string>}
 */

async function getContractId() {
	const json = await fetch('/wp-json/contract-form/generate-contract-id', {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		}
	}).then((response) => response.json());

	return json['contract-id'];
}
